export default {
      id: "menu__dashboard-usage",
      viewBox: "0 0 28 31",
      url: __webpack_public_path__ + "img/icons.svg#menu__dashboard",
      toString: function () {
        return this.url;
      }
    }